// components/PageLayout.js

import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

export const PageLayout = ({ backgroundImage }) => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <div
        className="fixed inset-0 -z-10 pointer-events-none blur-[1px]"
        style={{
          background: `linear-gradient(rgba(8, 11, 26, 0.767), rgba(3, 5, 17, 0.808)), url(${backgroundImage}) center/cover no-repeat`,
        }}
      />
      <div className="relative z-[1] min-h-[calc(100vh-var(--header-height))] pb-0">
        <Outlet />
      </div>
    </>
  );
};
